import { useCallback, useEffect, useState } from "react";
import { adminApi, errMsg, fmtDateTime } from "@/lib/api";
import { toast } from "sonner";

// Admin Master → Fiscal → Documentos: liga/desliga NFC-e, NF-e e NFS-e para TODAS as lojas.
// Lojas com regra própria (piloto ou bloqueio individual) são definidas no detalhe de cada cliente.
export function FiscalDocumentosAdmin() {
  const [d, setD] = useState(null);
  const [motivo, setMotivo] = useState("");
  const [busy, setBusy] = useState("");
  const load = useCallback(() => adminApi.get("/fiscal-documentos").then((r) => setD(r.data)).catch((e) => toast.error(errMsg(e))), []);
  useEffect(() => { load(); }, [load]);
  const alterar = async (tipo, ativo) => {
    if (motivo.trim().length < 5) { toast.error("Escreva o motivo (mínimo 5 caracteres)"); return; }
    const nome = d.documentos[tipo].nome;
    if (!window.confirm(`${ativo ? "LIGAR" : "DESLIGAR"} a emissão de ${nome} para todas as lojas (exceto as com regra própria)?`)) return;
    setBusy(tipo);
    try {
      await adminApi.put("/fiscal-documentos", { tipo, ativo, motivo: motivo.trim() });
      toast.success(`${nome} ${ativo ? "ligada" : "desligada"} para todas as lojas`);
      setMotivo(""); load();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(""); }
  };
  if (!d) return <p className="text-sm text-gray-500">Carregando…</p>;
  return (
    <div className="space-y-4" data-testid="fiscal-documentos-admin">
      <p className="text-sm text-gray-600">Ligue ou desligue cada tipo de nota para todas as lojas. Ex.: deixe a NFC-e desligada até concluir o
        credenciamento da FSC como desenvolvedora na SEFAZ. Notas já emitidas continuam podendo ser consultadas, impressas e canceladas.</p>
      <div className="grid gap-2 sm:grid-cols-3">
        {Object.entries(d.documentos).map(([k, x]) => (
          <div key={k} className="rounded-lg border p-3">
            <p className="font-semibold">{x.nome}</p>
            <p className={`text-sm ${x.geral ? "text-emerald-700" : "text-red-600"}`}>{x.geral ? "Ligada para todas" : "Desligada para todas"}{x.origem_geral === "padrao" ? " (padrão do sistema)" : ""}</p>
            {!x.geral && x.motivo_geral && <p className="text-xs text-gray-500">{x.motivo_geral}</p>}
            <button type="button" disabled={!!busy} onClick={() => alterar(k, !x.geral)}
              className={`mt-2 rounded-md px-3 py-1.5 text-sm font-medium text-white ${x.geral ? "bg-red-600" : "bg-emerald-600"} disabled:opacity-50`}
              data-testid={`fiscal-doc-geral-${k}`}>{x.geral ? "Desligar" : "Ligar"}</button>
          </div>
        ))}
      </div>
      <input className="w-full rounded-md border px-3 py-2 text-sm" placeholder="Motivo (obrigatório): ex. aguardando credenciamento na SEFAZ-SC"
        value={motivo} onChange={(e) => setMotivo(e.target.value)} maxLength={300} data-testid="fiscal-doc-motivo" />
      <div>
        <p className="mb-1 text-sm font-semibold">Lojas com regra própria</p>
        {d.excecoes.length ? (
          <ul className="divide-y rounded-lg border text-sm">
            {d.excecoes.map((t) => (
              <li key={t.id} className="px-3 py-2">{t.nome_fantasia || t.id}: {Object.entries(t.fiscal_documentos || {}).map(([k, r]) =>
                `${d.documentos[k]?.nome || k} ${r.modo === "liberado" ? "liberada (piloto)" : "bloqueada"}`).join(" · ")}</li>
            ))}
          </ul>
        ) : <p className="text-sm text-gray-500">Nenhuma. Para liberar uma loja piloto, abra o cliente no Admin Master.</p>}
      </div>
      {!!d.historico.length && (
        <div>
          <p className="mb-1 text-sm font-semibold">Histórico</p>
          <ul className="max-h-48 divide-y overflow-y-auto rounded-lg border text-xs">
            {d.historico.map((h, i) => <li key={i} className="px-3 py-1.5">{fmtDateTime(h.em)} · {d.documentos[h.tipo]?.nome || h.tipo} {h.ativo ? "ligada" : "desligada"} por {h.por}: {h.motivo}</li>)}
          </ul>
        </div>
      )}
    </div>
  );
}
